import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { hash } from '@ember/helper';
import { concat } from '@ember/helper';
import or from 'ember-truth-helpers/helpers/or';
import guid from 'volta/helpers/guid';
import isPresent from 'volta/helpers/is-present';
import orElse from 'volta/helpers/or-else';
import BvInlineError from 'volta/components/bv-inline-error';
import BvChoiceLabel from 'volta/components/bv-choice/label';
import BvStack from 'volta/components/bv-stack';
import BvText from 'volta/components/bv-text';
import type { TOC } from '@ember/component/template-only';
import type { ContentValue } from '@glint/template';
interface BvChoiceSignature {
    Args: {
        disabled?: boolean;
        error?: string;
        helpText?: ContentValue;
        id?: string;
        label?: ContentValue;
        labelClass?: string;
        labelHidden?: boolean;
        onClick?: () => void;
        onMouseOut?: () => void;
        onMouseOver?: () => void;
    };
    Blocks: {
        default: [{
                helpTextId?: string;
                errorId?: string;
            }];
    };
    Element: HTMLElement;
}
const BvChoiceComponent: TOC<BvChoiceSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  {{#let (orElse @id (guid)) as |id|}}
    {{#let
      (component
        BvChoiceLabel
        disabled=@disabled
        id=id
        label=@label
        labelHidden=@labelHidden
        labelClass=@labelClass
        onClick=@onClick
        onMouseOut=@onMouseOut
        onMouseOver=@onMouseOver
      )
      (concat id 'HelpText')
      (concat id 'Error')
      as |Label helpTextId errorId|
    }}
      {{#if (or @error (isPresent @helpText))}}
        <div class='bv-choice-container'>
          <Label ...attributes>
            {{yield (hash helpTextId=helpTextId errorId=errorId)}}
          </Label>
          <BvStack class='bv-choice__descriptions'>
            {{#if @error}}
              <div class='bv-choice__error'>
                <BvInlineError @fieldID={{id}} @message={{@error}} />
              </div>
            {{/if}}
            {{#if @helpText}}
              <div class='bv-choice__help-text' id={{helpTextId}}>
                <BvText @variant='body-sm' @color='subdued'>
                  {{@helpText}}
                </BvText>
              </div>
            {{/if}}
          </BvStack>
        </div>
      {{else}}
        <Label ...attributes>
          {{yield (hash helpTextId=helpTextId errorId=errorId)}}
        </Label>
      {{/if}}
    {{/let}}
  {{/let}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvChoiceComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        BvChoice: typeof BvChoiceComponent;
        'bv-choice': typeof BvChoiceComponent;
    }
}
